import Vue from 'vue'
import VueRouter from 'vue-router'
import {
    ajax
} from "jquery"; 

Vue.use(VueRouter)


const routes = [
    {
        path: '/schoolHome',
        name: 'SchoolHome',
        component: () =>
            import('../views/SchoolHome.vue'),
        children:[{            
            path: '/changePasswd',
            name: 'ChangePasswd',
            component: () =>
                import('../views/ChangePasswd.vue')
        },
        {            
            path: '/policy',
            name: 'Policy',
            component: () =>
                import('../views/Policy.vue')
        }
        ,
        {            
            path: '/instro',
            name: 'Instro',
            component: () =>
                import('../views/Instro.vue')
        }
    ]
    },

    {
        path: '/',
        name: 'Login',
        component: () =>
            import('../views/Login.vue')
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeResolve((to, from, next) => {
    let isAuthenticated = sessionStorage.getItem("loginState")
    if (to.name !== 'Login') {
        ajax({
                url: "/AdminAjax/login.ashx?type=checklogin",
                method: "POST",
                headers: {
                    "content-type": "application/x-www-form-urlencoded",
                }
            })
            .then((res) => {
                if (res.result !== "success") {

                    console.log("状态异常:" + JSON.stringify(res))
                    // return
                    alert("登录时效过期，请重新登录...")
                    next({
                        name: 'Login'
                    })

                } else {
                    // console.log("res:", res);
                    // 登录时限内, 设置userInfo 并 更改登录状态值 loginState

                    sessionStorage.setItem("loginState", "true")
                    isAuthenticated = "true";
                    let userInfo = sessionStorage.getItem("userInfo") ? JSON.parse(sessionStorage.getItem("userInfo")) : {};
                    
                        // 系统管理员的Info
                        userInfo.admin = res.model
                        sessionStorage.setItem("userInfo", JSON.stringify(userInfo))
                    
                    if (isAuthenticated != "true") {
                        // 登录时限失效时, 清空userInfo 并 更改登录状态值 loginState
                        sessionStorage.setItem("loginState", false)
                        isAuthenticated = "false";
                        sessionStorage.removeItem("userInfo")

                        alert('登录时效已过期,请重新登录');
                        next({
                            name: 'Login'
                        })
                    }
                    next()


                }

            })
            .catch((err) => {
                console.log("网络异常:", JSON.stringify(err))
            });
    } else next()
})


export default router